import type { Role } from './api';
import { DAYBOARD } from './help/dayboard';
import { STAFF } from './help/staff';
import { ADMIN } from './help/admin';
import { PHONE } from './help/phone';
import { REPORTS } from './help/reports';

export type HelpWhere = 'desk' | 'phone';
export interface HelpSection {
  id: string;
  group: string;
  title: string;
  who: Role[];
  where: HelpWhere[];
  /** page keys whose Help link opens here: desktop "day", "rotation"…; phone "phone:today"… */
  pages?: string[];
  body: string;
}

/**
 * The Help manual (HelpPage.tsx), in reading order. Written in plain words for the people using the app;
 * when a feature changes, change its section here too (CLAUDE.md "Help manual").
 */
export const HELP: HelpSection[] = [...DAYBOARD.slice(0, 2), ...PHONE.slice(0, 1), ...DAYBOARD.slice(2), ...STAFF, ...REPORTS, ...PHONE.slice(1), ...ADMIN];
